import { getImageByOrientation, Image, ImageKind } from "@blacknut/javascript-sdk/dist";
import { Button } from "@blacknut/react-sdk";
import { useSpatialNavigation } from "@blacknut/spatialnav-sdk/dist";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import { useProfiler } from "src/hooks/useProfiler";
import useGamePassUnlock from "src/utils/useGamePassUnlock";
import { ReactComponent as IcPass } from "../../assets/dist/ic_pass.svg";
import FadeInImage from "../FadeInImage/FadeInImage";
import { HeroTileProps } from "./HeroTile";
import styles from "./pass.module.scss";
import React, { useCallback } from "react";
import { AppLayout, State } from "core";
import { useSelector } from "react-redux";
import { useOrientation, OrientationType } from "src/utils/OrientationContext";
import { useScrollContext } from "src/utils/scroll/ScrollProvider";
const scrollTop = () => {
  document.documentElement.scroll && document.documentElement.scroll({ top: 0 });
};

export const getBackground = (
  device: string,
  orientation: OrientationType,
  images?: Image[],
) => {
  let background = undefined;
  if (images) {
    if (
      (device === AppLayout.PHONE || device === AppLayout.TABLET) &&
      orientation === "LANDSCAPE"
    ) {
      background = getImageByOrientation(
        orientation,
        images.filter((img) => img.kind === ImageKind.HERO_LANDSCAPE),
      );
    } else {
      background = getImageByOrientation(
        orientation,
        images.filter((img) => img.kind === ImageKind.HERO),
      );
    }
  }
  return background;
};
const HeroTilePass = ({ item, list }: HeroTileProps) => {
  const { layout } = useSelector((state: State) => state.globalState);
  const { orientation } = useOrientation();

  const Root = useProfiler("hero", {
    id: item.gamePass?.uuid || "",
  });
  const background = getBackground(layout, orientation, list.tiles[0].gamePass?.images);
  const { active: spatialNavigationActive } = useSpatialNavigation();
  const [ref, inView] = useInView({
    threshold: 0,
    rootMargin: "33% 0px",
  });
  const { t } = useTranslation();
  const { unlockPass } = useGamePassUnlock({
    ...(item.gamePass && {
      passId: item.gamePass.uuid,
    }),
  });
  const logo = list.imgLogo && list.imgLogo.length > 0 && list.imgLogo[0];

  const { profile } = useSelector((state: State) => state.profilesState);
  const isMaster = profile?.isMaster;

  const { update: updateScrollContext } = useScrollContext();
  const onFocus = useCallback(
    (e) => {
      const selector = "." + [...e.srcElement.classList].join(".");
      updateScrollContext(selector);
      scrollTop();
    },
    [updateScrollContext],
  );

  return (
    <Root>
      <div
        className={clsx(
          styles.container,
          styles.gamepass,
          spatialNavigationActive && styles.focusableBtn,
        )}
      >
        {background && (inView || process.env.NODE_ENV === "test") && (
          <FadeInImage className={styles.image} image={background} />
        )}

        <div className={clsx(styles.content)} ref={ref}>
          {logo && <img className={styles.passLogo} src={logo.url} />}
          <div className={clsx(styles.title)}>{list.tiles[0].gamePass?.title}</div>
          <div className={clsx(styles.description)}>
            {list.tiles[0].gamePass?.description}
          </div>
          <div className={styles.buttonsContainer}>
            <Button
              className={styles.seeMoreBtn}
              variant={"primary"}
              testID="unlockPass"
              onClick={() =>
                unlockPass(undefined, list.tiles[0].gamePass?.ubisoftSSORequired)
              }
              onFocus={onFocus}
            >
              <IcPass />
              {t("bnPlus.unlockpass.play", {
                name: list.tiles[0].gamePass?.name,
              })}
            </Button>
          </div>
          <div className={styles.specialGameInfo}>{t("game.unlockPassWithSub")}</div>
          <div className={styles.secondaryAccountDisclaimer}>
            {!isMaster && t("profile.accessFromMain")}
          </div>
        </div>
      </div>
    </Root>
  );
};
export default HeroTilePass;
